import { useLayoutEffect } from 'react'

import { CountryCode } from 'root-constants/common'

const PUBLIC_KEY = 'live_pk_etV3XZ8OA6ylGKrZ09rLTw'

export const useEbanxInit = () => {
  useLayoutEffect(() => {
    if (window.EBANX) {
      window.EBANX.init({
        publicIntegrationKey: PUBLIC_KEY,
        country: CountryCode.BRAZIL,
        mode: 'production',
      })
    } else {
      console.error('EBANX.js script not loaded or EBANX object not found.')
    }
  }, [])
}
